import { type ReactElement } from 'react';

import styles from './ChartPatterns.module.css';

export const ChartPatterns = ({
  getId,
}: {
  getId: (name: string) => string;
}): ReactElement => (
  <>
    <pattern
      id={getId('lines')}
      patternUnits="userSpaceOnUse"
      width="4.75"
      height="4.75"
      patternTransform="rotate(45)"
    >
      <line
        x1="0"
        y1="2.375"
        x2="4.75"
        y2="2.375"
        strokeWidth="2.4"
        className={styles.patternStroke}
      />
    </pattern>
    <pattern
      id={getId('dots')}
      patternUnits="userSpaceOnUse"
      width="5.52"
      height="5.52"
    >
      <circle cx="2.76" cy="2.76" r="2.4" className={styles.patternFill} />
    </pattern>
    <pattern
      id={getId('waves')}
      patternUnits="userSpaceOnUse"
      width="36"
      height="4.62"
      viewBox="-0.499 -1 30 3.85"
      preserveAspectRatio="none"
    >
      <g transform="translate(-30 -3.85)">
        <path
          d="M0 1.925C0 1.925 7.5 6.255 15 1.925C22.5 -2.406 30 1.925 30 1.925"
          className={styles.waveStroke}
        />
      </g>
      <g transform="translate(0 -3.85)">
        <path
          d="M0 1.925C0 1.925 7.5 6.255 15 1.925C22.5 -2.406 30 1.925 30 1.925"
          className={styles.waveStroke}
        />
      </g>
      <g transform="translate(-30 0)">
        <path
          d="M0 1.925C0 1.925 7.5 6.255 15 1.925C22.5 -2.406 30 1.925 30 1.925"
          className={styles.waveStroke}
        />
      </g>
      <path
        d="M0 1.925C0 1.925 7.5 6.255 15 1.925C22.5 -2.406 30 1.925 30 1.925"
        className={styles.waveStroke}
      />
    </pattern>
    <pattern
      id={getId('checker')}
      patternUnits="userSpaceOnUse"
      width="19.2"
      height="9.6"
    >
      <rect width="9.6" height="4.8" className={styles.patternFill} />
      <rect
        x="9.6"
        y="4.8"
        width="9.6"
        height="4.8"
        className={styles.patternFill}
      />
      <circle cx="14.4" cy="2.4" r="2.4" className={styles.patternFill} />
      <circle cx="4.8" cy="7.2" r="2.4" className={styles.patternFill} />
    </pattern>
    <pattern
      id={getId('hatch')}
      patternUnits="userSpaceOnUse"
      width="6"
      height="6"
    >
      <line
        x1="0"
        y1="3"
        x2="6"
        y2="3"
        strokeWidth="1.4"
        className={styles.patternStroke}
      />
    </pattern>
  </>
);
